import {
	Box,
	Button,
	Text,
	Title,
	TextInput,
	LoadingOverlay,
} from '@mantine/core'
import { useState } from 'react'
import { useAppDispatch } from './../state/app-store'
import { useRouter } from 'next/router'

import { THEME_COLOURS } from 'pages/_app'
import * as Actions from './../state/actions'
import * as AnalyitcsUtil from 'lib/analytics'
import { useMutation } from '@apollo/client'
import { Mutations } from 'lib/queries'

const SignUpNudge = ({
	context,
}: {
	context:
		| {
				variant: 'GUIDES'
				contextMessage: string
				tripName: string
				guideCount: number
		  }
		| {
				variant: 'REVIEWS'
				contextMessage: string
				guideName: string
				reviewCount: number
		  }
}) => {
	const [email, setEmail] = useState('')
	const dispatch = useAppDispatch()
	const router = useRouter()

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		await handleEmailSubmit(email)
	}

	const [registerViaGuard, { loading: isRegistering }] = useMutation(
		Mutations.REGISTER_VIA_GUARD,
	)

	const handleEmailSubmit = async (email: string) => {
		try {
			AnalyitcsUtil.guideListGuardSignUp()
			const { data } = await registerViaGuard({
				variables: {
					input: {
						email,
						context: context.contextMessage,
					},
				},
			})

			const { success, user, token } = data.registerViaGuard

			if (success) {
				dispatch(Actions.attemptLoginSucceeded(token, user))
			} else {
				// todo: show error to user
				console.error('Error registering:', data.registerViaGuard.error)

				if (data.registerViaGuard.error === 'Email already in use') {
					router.push(`#email-already-registered`)
					dispatch(Actions.openLogin())
				}
			}
		} catch (error) {
			console.error('Error submitting email:', error)
		}
	}

	return (
		<Box
			style={{
				backgroundColor: `${THEME_COLOURS[9]}`,
				padding: 'var(--mantine-spacing-xl)',
				borderRadius: 'var(--mantine-radius-md)',
				textAlign: 'center',
				backdropFilter: 'blur(4px)',
				boxShadow: `0 4px 24px ${THEME_COLOURS[9]}`,
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '90%',
				maxWidth: '600px',
				zIndex: 10,
				border: `1px solid ${THEME_COLOURS[9]}`,
			}}
		>
			<LoadingOverlay visible={isRegistering} />
			<Title order={2} mb="md">
				{context.variant === 'GUIDES' && (
					<>
						Compare {context.guideCount} Guides for {context.tripName}
					</>
				)}
				{context.variant === 'REVIEWS' && (
					<>
						View {context.reviewCount} Reviews for {context.guideName}
					</>
				)}
			</Title>
			<Text size="lg" mb="xl">
				{context.variant === 'GUIDES' && (
					<>
						See <strong>Prices</strong>, <strong>Ratings</strong>, and{' '}
						<strong>Contact details</strong>. Enter your email to get instant
						access.
					</>
				)}
				{context.variant === 'REVIEWS' && (
					<>
						See all <strong>Reviews</strong>, filter by relevant keyword and{' '}
						<strong>Mountain</strong>.
					</>
				)}
			</Text>
			<form
				onSubmit={handleSubmit}
				style={{
					display: 'flex',
					gap: '1rem',
					maxWidth: '500px',
					margin: '0 auto',
				}}
			>
				<TextInput
					required
					type="email"
					placeholder="Enter your email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					style={{ flex: 1 }}
					disabled={isRegistering}
				/>
				<Button
					type="submit"
					className="plausible-event-name=Guides-Access-click signup-nudge-button"
					loading={isRegistering}
					disabled={isRegistering}
				>
					<Box hiddenFrom="sm">Access</Box>
					<Box visibleFrom="sm">Access Community</Box>
				</Button>
			</form>

			<Text size="sm" mt="md" color="dimmed">
				Already a member?{' '}
				<a
					href="#"
					onClick={(e) => {
						e.preventDefault()
						dispatch(Actions.openLogin())
					}}
					style={{ fontWeight: 'bold', cursor: 'pointer' }}
				>
					Login
				</a>
			</Text>
		</Box>
	)
}

export default SignUpNudge
